export var initialState = {
    dim_new_alldernow_emp_id: "",
    dim_mst_new_alldernow_role_id: "",
    dim_mst_os_ids: [],
    dim_warehouse_ids: []
};
